const relativity_sso_config = {
  clientId: 'a15ef688-ddc4-43fb-865c-e29db2d9b6c9',
  authority: 'https://login.microsoftonline.com/8ac79825-2294-4130-8b7a-f2a3ffb33e0b'
}

const intel_sso_config = {
  clientId: '19be5237-b252-4504-bfec-04076143020f',
  authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d'
}

export const environment = {
  production: true,
  baseUrl: 'https://eae.intel.smartoperator.co/eaeservices/api/v1',
  msalConfig: {
    auth: intel_sso_config
  },
  apiConfig: {
    scopes: ['openid', 'profile'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  }
}
